






































import Vue from 'vue'
import iNoBounce from 'inobounce'

import types from '../store/types'

import FileSelector from '../components/FileSelector.vue'
import BaseHeader from '../components/Base/Header.vue'
import BaseSelectWrap from '../components/Base/SelectWrap.vue'

export default Vue.extend({
  name: 'material',

  components: {
    FileSelector,
    BaseHeader,
    BaseSelectWrap,
  },

  beforeCreate() {
    iNoBounce.disable()
    window.scrollTo(0, 0)

    if (this.$store.state.Shape.list.length === 0) {
      this.$router.push('editor')
      return
    }
  },

  data(): {
    selected: number | ''
  } {
    return {
      selected: '',
    }
  },

  computed: {
    materials(): any[] {
      if (
        this.selected === null ||
        this.selected === '' ||
        this.$store.state.Shape.list.length === 0
      ) {
        return []
      }

      const result: any[] = []
      this.optgroups[this.selected].list.forEach((el: any) => {
        result.push(this.$store.state.Shape.list[el.index])
      })

      return result
    },
    optgroups(): any[] {
      return this.$store.state.Shape.group
    },
    currentShape(): number {
      return this.$store.state.Current.shape
    }
  },

  methods: {
    selectGroup() {
      this.$store.commit(types.mutations.CURRENT_SHAPE, -1)
    },
    selectShape(index: number) {
      this.$store.commit(types.mutations.CURRENT_SHAPE, index)
    },
    selectFile(e: FileReader | null) {
      this.$store.commit(types.mutations.CURRENT_FILE, e)
      this.$router.push('editor')
    }
  }
})
